import {
  SideBarStudentItem,
  StudentSideBarItemType,
} from './componenets/side-bar-student-item';
import React from 'react';
export interface SideBarAdministrationModel {
  onClick: (type: StudentSideBarItemType) => void;
}
export const SideBarAdministration: React.FC<SideBarAdministrationModel> = ({
  onClick,
}) => {
  return (
    <div style={{ width: '250px', marginLeft: '16px' }}>
      <SideBarStudentItem
        type={StudentSideBarItemType.PROFILE}
        text={'פרטים אישיים'}
        onClick={onClick}
      />

      <SideBarStudentItem
        type={StudentSideBarItemType.PERMISSIONS}
        text={'ממשק משתמש'}
        onClick={onClick}
      />
    </div>
  );
};
